import {
  specialCharactersNotAllowedValidation,
  specialCharactersNotAllowedValidationForOptionalField,
} from "../../helpers/constants/commonValidationSchemaUtils";
import { commonSiteCoreKeys } from "../../helpers/constants/siteCoreKeys";
import { SiteCoreValidation } from "../../redux/slices/appState/models";
import { ManageLocaleLanguage } from "./Models";
import * as Yup from "yup";

export const manageLocaleValidationSchema = (
  mergedLanguages: ManageLocaleLanguage[],
  fetchValidationMessage: SiteCoreValidation,
) => {
  return Yup.object().shape(
    mergedLanguages.reduce(
      (acc, { value, isRequired }) => {
        acc[value] = isRequired
          ? specialCharactersNotAllowedValidation(
              fetchValidationMessage(commonSiteCoreKeys.requiredValidation),
              fetchValidationMessage(
                commonSiteCoreKeys.fieldContainsInvalidCharactersErrorMessage,
              ),
            )
          : specialCharactersNotAllowedValidationForOptionalField(
              fetchValidationMessage(
                commonSiteCoreKeys.fieldContainsInvalidCharactersErrorMessage,
              ),
            );
        return acc;
      },
      {} as Record<string, Yup.StringSchema>,
    ),
  );
};
